import { useTranslation } from "react-i18next";
import { useUpdateUserProfileMutation } from "../api/userAuthApi";
import { useMutationWithFeedback } from "../../../common/hooks/useMutationWithFeedback";
import { UpdateProfilePayload, UserProfile } from "../types/userAuthApiTypes";

export const useProfileAddressUpdate = (type: "billing" | "shipping") => {
  const { t } = useTranslation();
  const [updateProfile, mutationResult] = useUpdateUserProfileMutation();

  const successMessage =
    type === "billing"
      ? t(
          "user.addresses.billingSaveSuccess",
          "Billing address saved successfully."
        )
      : t(
          "user.addresses.shippingSaveSuccess",
          "Shipping address saved successfully."
        );

  const { trigger: handleUpdate, isLoading: isUpdating } =
    useMutationWithFeedback<UserProfile, UpdateProfilePayload>({
      mutation: [updateProfile, mutationResult],
      successMessage,
      loadingMessage: t("user.addresses.saving", "Saving address..."),
      errorMessages: {
        default: t(
          "user.addresses.saveError",
          "Failed to save address. Please try again."
        ),
      },
    });

  return { handleUpdate, isUpdating };
};
